import React from "react";
import { connect } from "react-redux";
import { loadTabs } from "../../../Header/actions";
import LoadingOverlay from "../../../Shared/LoadingOverlay";
import Centros from "./Centros/view";
import Prestaciones from "./Prestaciones/view";
import Baterias from "./Baterias/view";
import Aperturas from "./Aperturas/view";
import FeriadosAdmin from "./FeriadosAdmin/view";
import Cupos from "./Cupos/view";
import Bloqueos from "./Bloqueos/view";
import Empresas from "./Empresas/view";
import { push } from "connected-react-router";
import { checkAccess, ids, realCheckAccess } from "../../../../helpers/rolAccess";
import { paths } from "../../../../config/routes";

const headerTitle = "SEL";
class MantenedoresSEL extends React.PureComponent {
  componentDidUpdate = (prevProps) => {
    if ((prevProps.userAccessIds === null && Array.isArray(this.props.userAccessIds))
      || this.props.currentHeader !== headerTitle) {
      this.loadTabs();
    }
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root))
    }
  }

  loadTabs = () => {
    const tabs = [];

    if (checkAccess(ids.mantenedorGeneral, this.props.userAccessIds)) {
      tabs.push({ text: "Centros", contentId: 0 });
      tabs.push({ text: "Prestaciones", contentId: 1 });
      tabs.push({ text: "Baterías", contentId: 2 });
      tabs.push({ text: "Tipos de cupos", contentId: 3 });
      tabs.push({ text: "Aperturas", contentId: 4 });
      tabs.push({ text: "Feriados", contentId: 5 });
      tabs.push({ text: "Bloqueos", contentId: 6 });
      tabs.push({ text: "Empresas", contentId: 7 });
    }

    this.props.dispatch(loadTabs(headerTitle, "", tabs, tabs.length ? tabs[0].contentId : null));
  }

  renderBody = () => {
    switch (this.props.selectedTab) {
      case 0:
        return <Centros />;
      case 1:
        return <Prestaciones />;
      case 2:
        return <Baterias />;
      case 3:
        return <Cupos />;
      case 4:
        return <Aperturas />;
      case 5:
        return <FeriadosAdmin />;
      case 6:
        return <Bloqueos />;
      case 7:
        return <Empresas />;
      default:
        return <div />;
    }
  }

  render() {
    return (
      <div>
        {this.props.isLoading && <LoadingOverlay />}
        {this.renderBody()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedTab: state.header.contentId,
  currentHeader: state.header.title,
  isLoading: state.mantenedores.isLoading,
  userAccessIds: state.global.userAccessIds,
  companyId: state.global.companyId,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(MantenedoresSEL);
